import { render } from "./LiveAssistant.vue?vue&type=template&id=69cb480c&scoped=true&ts=true"
import script from "./LiveAssistant.vue?vue&type=script&lang=ts"
export * from "./LiveAssistant.vue?vue&type=script&lang=ts"

import "./LiveAssistant.vue?vue&type=style&index=0&id=69cb480c&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69cb480c"]])

export default __exports__